/**
 * App shell tokens — sticky chrome, bottom nav, section wrappers.
 * PWA-first touch targets; desktop adds horizontal breathing room.
 */
import { semanticColors } from './colors';
import { glassSurfaces } from './surfaces';
import { spacing } from './spacing';

export const shell = {
  /** Sticky top header bar */
  header: {
    base: `sticky top-0 ${glassSurfaces.chrome} border-b ${semanticColors.border.DEFAULT}`,
    inset: `pt-[max(0.5rem,var(--safe-top))] ${spacing.inset.md}`,
    minHeight: 'min-h-[3.25rem]',
  },
  /** Sticky bottom navigation (PWA) */
  bottomNav: {
    base: `fixed bottom-0 inset-x-0 ${glassSurfaces.chrome} border-t ${semanticColors.border.DEFAULT} pb-[max(0.5rem,var(--safe-bottom))]`,
    height: 'min-h-[3.75rem]',
    z: 'z-[300]',
  },
  /** Main scroll region below header */
  main: {
    base: 'min-h-0 flex-1 overflow-y-auto overscroll-y-contain',
    inset: `${spacing.inset.sm} md:px-6 lg:px-8`,
    maxWidth: 'max-w-6xl mx-auto w-full',
  },
  /** Section wrapper inside home feed */
  section: {
    base: spacing.section.md,
    card: `${semanticColors.surface.DEFAULT} border ${semanticColors.border.DEFAULT} rounded-[2rem] p-5 md:p-6`,
  },
};

/** Minimum touch target for primary controls (WCAG / PWA) */
export const touchTarget = {
  min: 'min-h-[44px] min-w-[44px]',
  comfortable: 'min-h-[48px]',
  chip: 'min-h-[36px]',
};
